import { CheckCircle, Clock, AlertCircle } from 'lucide-react';

interface PaymentSummaryCardProps {
  totalReceived: number;
  totalPending: number;
  outstanding: number;
}

/**
 * Payment summary card showing received, pending, and outstanding amounts
 */
export function PaymentSummaryCard({
  totalReceived,
  totalPending,
  outstanding,
}: PaymentSummaryCardProps) {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(amount);
  };

  return (
    <div className="bg-white rounded-[20px] border border-[#d9d9d9] p-6">
      <h3 className="text-lg font-semibold mb-4">Payment Summary</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Received */}
        <div className="flex items-center gap-3">
          <div className="p-2 bg-green-100 rounded-full">
            <CheckCircle className="h-6 w-6 text-green-600" />
          </div>
          <div>
            <p className="text-sm text-gray-500">Received</p>
            <p className="text-xl font-bold text-green-600">
              {formatCurrency(totalReceived)}
            </p>
          </div>
        </div>

        {/* Pending */}
        <div className="flex items-center gap-3">
          <div className="p-2 bg-amber-100 rounded-full">
            <Clock className="h-6 w-6 text-amber-600" />
          </div>
          <div>
            <p className="text-sm text-gray-500">Pending</p>
            <p className="text-xl font-bold text-amber-600">
              {formatCurrency(totalPending)}
            </p>
          </div>
        </div>

        {/* Outstanding */}
        <div className="flex items-center gap-3">
          <div className="p-2 bg-red-100 rounded-full">
            <AlertCircle className="h-6 w-6 text-red-600" />
          </div>
          <div>
            <p className="text-sm text-gray-500">Outstanding</p>
            <p className="text-xl font-bold text-red-600">
              {formatCurrency(outstanding)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
